import React from "react";

const FormSkeleton = (): JSX.Element => (
  <div className="w-full animate-pulse p-4">
    <div className="bg-neutral-1 rounded-md border border-neutral-5 p-6 md:p-8 min-h-[80vh] flex flex-col">
      <div className="space-y-2">
        <div className="h-8 w-1/4 max-w-[180px] rounded bg-neutral-4" />
      </div>

      <div className="mt-8 space-y-6 flex-1">
        {[0, 1, 2, 3].map(i => (
          <div key={i} className="space-y-2">
            <div className="h-4 w-32 rounded bg-neutral-5" />
            <div className="h-10 w-full rounded-md bg-neutral-4" />
          </div>
        ))}
      </div>
    </div>

    <div className="mt-4 flex justify-end">
      <div className="h-10 w-24 rounded-md bg-neutral-4" />
    </div>
  </div>
);

export default FormSkeleton;
